import { request } from '@/api/apiUtils';
import { createEntityQuery } from '@/data/createEntityQuery';
import type { EntityDefinition, FetcherEntry } from '@/data/types';
import type { TextAtomType } from '@/types';

/** Root: query-key prefix for this entity's slice of the cache (ADR 0010) */
export const TEXT_ATOM_TYPES_ROOT = ['text-atom-types'] as const;

interface TextAtomTypesResponse {
    data: { text_atom_type_id?: TextAtomType[] };
}

const fetchers = {
    /** The deployment's `text_atom_types` table. Read-only and effectively
     *  immutable — the rows only change when a migration runs — so callers
     *  pin it with an infinite stale time. */
    dictionary: {
        key: () => [...TEXT_ATOM_TYPES_ROOT, 'dictionary'] as const,
        fetch: async (): Promise<TextAtomType[]> => {
            const response: TextAtomTypesResponse = await request('dictionary/text-atom');
            return response.data.text_atom_type_id ?? [];
        },
    },
    // biome-ignore lint/suspicious/noExplicitAny: required for generic type inference
} satisfies Record<string, FetcherEntry<any, any>>;

export const textAtomTypesEntity: EntityDefinition<typeof fetchers> = {
    name: 'textAtomTypes',
    roots: [TEXT_ATOM_TYPES_ROOT],
    fetchers,
};

export const useTextAtomTypesDictionary = createEntityQuery(textAtomTypesEntity, 'dictionary');
